module.exports = __webpack_public_path__ + "img/payment-logo-twint.0c973ae0.png";